import { toast } from 'react-toastify';

class Toast {
	static defaultConfig = {
		position: 'top-center',
		duration: 3000,
		style: { zIndex: 99999 }
	};

	static showToast(message, type, config) {
		const mergedConfig = { ...this.defaultConfig, ...config };
		switch (type) {
			case 'error':
				toast.error(message, mergedConfig);
				break;
			case 'warn':
				toast(message, { ...mergedConfig, icon: '⚠️' });
				break;
			case 'info':
				toast(message, { ...mergedConfig, icon: 'ℹ️' });
				break;
			case 'success':
				toast.success(message, mergedConfig);
				break;
			case 'applepay':
				toast.success(message, { ...mergedConfig, className: 'bg-black text-white rounded-lg' });
				break;
			default:
				toast(message, mergedConfig);
				break;
		}
	}

	static error(message, config = {}) {
		this.showToast(message, 'error', config);
	}

	static warn(message, config = {}) {
		this.showToast(message, 'warn', config);
	}

	static info(message, config = {}) {
		this.showToast(message, 'info', config);
	}

	static success(message, config = {}) {
		this.showToast(message, 'success', config);
	}

	static applePay(message, config = {}) {
		this.showToast(message, 'applepay', config);
	}
}

export default Toast;
